import { useTranslation } from "@next-platform/client-common-core";
import type { LorebookEntry } from "@next-platform/packages-ts-types";
import { useCallback, useState } from "react";

import { PageLayout } from "@/components";

import EntriesListServer from "./components/EntriesList/EntriesListServer";
import ModalEntry from "./components/ModalEntry";

interface ILorebookDetailContentProps {
  entries: LorebookEntry[];
  totalEntryCount: number;
  searchValue: string;
  onSearchChange: (next: string) => void;
  onEndReached: () => void;
  isLoadingFirstPage: boolean;
  isLoadingMore: boolean;
  hasMore: boolean;
  hasError: boolean;
  onRetry: () => void;
  onRetryLoadMore: () => void;
}

export default function LorebookDetailContent({
  entries,
  totalEntryCount,
  searchValue,
  onSearchChange,
  onEndReached,
  isLoadingFirstPage,
  isLoadingMore,
  hasMore,
  hasError,
  onRetry,
  onRetryLoadMore,
}: ILorebookDetailContentProps) {
  const { t } = useTranslation();
  const [stateEntryData, setStateEntryData] = useState<LorebookEntry | undefined>(undefined);

  const handleEditEntry = useCallback((entry: LorebookEntry) => {
    setStateEntryData(entry);
  }, []);

  const handleCloseModal = useCallback(() => {
    setStateEntryData(undefined);
  }, []);

  return (
    <>
      <PageLayout.Header title={t("lorebook:profile.entries.title")} tooltip={t("lorebook:profile.entries.tooltip.description")} />
      <PageLayout.Content classNames="flex flex-col gap-5">
        <EntriesListServer
          entries={entries}
          totalEntryCount={totalEntryCount}
          searchValue={searchValue}
          onSearchChange={onSearchChange}
          onEditEntry={handleEditEntry}
          onEndReached={onEndReached}
          isLoadingFirstPage={isLoadingFirstPage}
          isLoadingMore={isLoadingMore}
          hasMore={hasMore}
          hasError={hasError}
          onRetry={onRetry}
          onRetryLoadMore={onRetryLoadMore}
        />
      </PageLayout.Content>
      <ModalEntry isOpen={!!stateEntryData} onClose={handleCloseModal} entryData={stateEntryData} isReadOnly={true} />
    </>
  );
}
